export default function PageBanner({ overline, title, subtitle, image }) {
  return (
    <section
      data-testid="page-banner"
      className="relative w-full h-[52vh] min-h-[380px] overflow-hidden bg-[#1A2421]"
    >
      <img
        src={image}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/15" />
      <div className="relative z-10 h-full container-tmb px-6 flex items-end pb-16">
        <div className="max-w-2xl text-white">
          {overline && (
            <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#D99A29] mb-4">
              {overline}
            </div>
          )}
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1.05] mb-4">
            {title}
          </h1>
          {subtitle && (
            <p className="text-base md:text-lg text-white/85 max-w-xl leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
